query allSoccerTeams(
  $first: Int,
  $offset: Int,
  $filter: SoccerTeamFilter,
  ) {
  teams: allSoccerTeams(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
        squad
        shortName
        name
        source
        teamId
        division
        stadium
        city
        state
        mappings: soccerTeamMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingType
        }
      }
    }
    totalCount
  }
}
